module.exports = __webpack_public_path__ + "img/widgets-screenshot.b5af515b.png";